import React from 'react'
import Homepage from './Homepage'
import { VolnyEmail } from '../components/widgets/Email'
import { WIDGETS } from '../constants'

export default class Volny extends Homepage {
  constructor (props) {
    super(props)

    const {
      widgets: {
        email
      },
      containers: {
        inbox
      }
    } = this.state

    this.dynamicWidgets[WIDGETS.HOMEPAGE.EMAIL] = <VolnyEmail widget={email} container={inbox}/>
  }
}
